import { onCLS, onFCP, onINP, onLCP, onTTFB, type MetricWithAttribution } from "web-vitals/attribution";

export const reportWebVitals = (onReport: (metric: MetricWithAttribution) => void) => {
    onLCP(onReport);
    onFCP(onReport);
    onCLS(onReport);
    onINP(onReport);
    onTTFB(onReport);
};
